import { TabGuardFeature } from "ag-grid-community";

export const environment = {
  production: false,
  debug: false,
  useRecaptcha: true,
  showThemeSwitcher: true, // Always show in development
  clientId: '',
  orgId: '',
  confUrl: 'https://tl-infra.apis.tensorlinks.dev',
  //confUrl: 'http://localhost:4300',
  apiKey: 'AIzaSyAtBxir34odZFDYlGve33oDRz367zupPTM',
  apiUrl: 'https://apis.tensorlinks.dev/patient-portal',
  //apiUrl: 'http://localhost:4300',

  tenantId: 'brightsmiledental',
  googleMapsApiKey: '', // TODO: Create restricted Maps API key when patient portal goes live
  firebase: {
    apiKey: "AIzaSyDRNb3ei0euI5uHVKA2wU1cum96Ytytwd8",
    authDomain: "project-001-dev.firebaseapp.com",
    projectId: "project-001-dev",
    storageBucket: "project-001-dev.firebasestorage.app",
    messagingSenderId: "1011039981452",
    appId: "1:1011039981452:web:b7d9828b34d9d77c2c90a9",
    measurementId: "G-CXNQZZXSDT"
  },
  recaptcha: {
    siteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  },
  release: {
    version: '1.2.2',
    date: '2025-06-30',
    notes: 'Env release',
  }
};